<template>
  <!-- handling the back event in case we want to add it quickly, because it's nice -->
  <DrawerHeader @close="emit('back')">
    Change Given
  </DrawerHeader>
  <div class="flex flex-1 flex-col px-6">
    <div class="mb-2 flex flex-1 flex-col px-4">
      <div
        class="flex flex-1 flex-col items-center justify-center"
      >
        <CustomAmountDisplay :value="changeGiven" />
      </div>
      <div class="flex items-center justify-between">
        <!-- <StatRow label="CASH TENDERED" value="" -->
        <h3 class="text-xs text-background-fg/50">
          Change
        </h3>
        <p
          class="text-lg font-bold leading-tight text-background-fg/87"
        >
          {{ formatToMerchantCurrencyString(changeGiven) }}
        </p>
      </div>
      <div class="flex items-center justify-between">
        <h3 class="text-xs text-background-fg/50">
          Amount Kept
        </h3>
        <p
          class="text-lg font-bold leading-tight text-background-fg/87"
        >
          {{
            formatToMerchantCurrencyString(
              maxChange - changeGiven
            )
          }}
        </p>
      </div>
    </div>
    <BaseNumpad
      :model-value="changeGiven"
      @update:model-value="onUpdateChangeGiven"
    />
  </div>
  <div
    class="flex flex-col items-center justify-center space-y-3 p-4"
  >
    <ActionButtonPrimary
      class="w-full"
      @click="emit('submit', cashTendered, changeGiven)"
    >
      {{
        changeGiven
          ? ` Give ${formatToMerchantCurrencyString(
              changeGiven
            )} Change`
          : "No change"
      }}
    </ActionButtonPrimary>
    <ActionButtonSecondary
      class="w-full"
      @click="onGiveFullChange"
    >
      Give
      {{
        formatToMerchantCurrencyString(
          cashTendered - invoiceAmountGross
        )
      }}
      Change
    </ActionButtonSecondary>
  </div>
</template>

<script lang="ts">
export default {
  inheritAttrs: false,
}
</script>

<script setup lang="ts">
const { formatToMerchantCurrencyString } = useCurrency()

const props = defineProps<{
  cashTendered: number
  invoiceAmountGross: number
}>()

const emit = defineEmits<{
  (
    event: "submit",
    cashTendered: number,
    changeGiven: number
  ): void
  (event: "back"): void
}>()

const changeGiven = ref(0)
const maxChange = computed(() =>
  Math.max(0, props.cashTendered - props.invoiceAmountGross)
)

const onUpdateChangeGiven = (newValue: number) => {
  if (newValue <= maxChange.value) {
    changeGiven.value = newValue
  }
}

const onGiveFullChange = () => {
  emit(
    "submit",
    props.cashTendered,
    props.cashTendered - props.invoiceAmountGross
  )
}
</script>
